export const clientThemeLastminute = {
    mainLayout: {
        backgroundColor: '#f4f4f5',
        hover: {
            backgroundColor: '#1A4D66',
        },
    },
    topBar: {
        backgroundColor: '',
        contrastText: '',
        contrastLinkText: '#E50000',
        userIcon: '#E50000',
        brandLogo: {
            maxWidth: '120px',
            paddingTop: '0px',
        },
        menuBarIcon: {
            color: '#a1a1aa',
        },
    },
    sidebar: {
        fontSize: '14px',
        backgroundColor: '#121315',
        darkBackgroundColor: '#27272a',
        sideMenuActive: {
            backgroundColor: '',
            contrastText: '',
        },
        sideMenuHover: {
            backgroundColor: '',
            contrastText: '',
        },
    },
    footer: {
        backgroundColor: '',
        contrastText: '',
    },
    charts: {
        fill: '#E50000',
        stroke: '#E50000',
        lineCharts: {
            stroke: '#E50000',
            fill: '#E50000',
        },
        areaCharts: {
            gradient: {
                start: '#E50000',
                stop: 'rgba(229, 0, 0, 0.6)',
            },
            stroke: '#E50000',
            fill: 'rgba(229, 0, 0, 0.6)',
            chargebacksByPostDateChart: {
                stroke: '#E50000',
                fill: 'rgba(229, 0, 0, 0.6)',
            },
            newAlertsByDateChart: [
                {
                    stroke: '#AC0000',
                    fill: 'rgba(172, 0, 0, 0.5)',
                },
                {
                    stroke: '#E50000',
                    fill: 'rgba(229, 0, 0, 0.5)',
                },
                {
                    stroke: '#E50000',
                    fill: 'rgba(229, 0, 0, 0.5)',
                },
                {
                    stroke: '#E50000',
                    fill: 'rgba(229, 0, 0, 0.5)',
                },
                {
                    stroke: '#E50000',
                    fill: 'rgba(229, 0, 0, 0.5)',
                },
                {
                    stroke: '#E50000',
                    fill: 'rgba(229, 0, 0, 0.5)',
                },
                {
                    stroke: '#E50000',
                    fill: 'rgba(229, 0, 0, 0.5)',
                },
            ],
        },
        barCharts: {
            fill: '#E50000',
            byPlatformBarChart: { fill: '#E50000' },
            byBinBarChart: { fill: '#E50000' },
            ertsByRevenueChart: {
                bar1Fill: '#E50000',
                bar2Fill: '#AC0000',
            },
        },
        lineBarCharts: {
            byNonUniqueCustomerLineBarChart: {
                barColor: '#E50000',
                lineColor: '#E50000',
            },
        },
        pieCharts: {
            defaultPieChart: [
                '#E50000',
                '#1A4D66',
                '#4A5767',
                '#23826F',
                '#AC0000',
            ],
            dashboardPieChart: [
                '#E50000',
                '#1A4D66',
                '#4A5767',
                '#23826F',
                '#AC0000',
            ],
            byReasonCodePieChart: [
                '#E50000',
                '#1A4D66',
                '#4A5767',
                '#23826F',
                '#AC0000',
            ],
            byReasonCodeDistributionPieChart: [
                '#E50000',
                '#1A4D66',
                '#4A5767',
                '#23826F',
                '#AC0000',
            ],
            byCardTypePieChart: [
                '#E50000',
                '#1A4D66',
                '#4A5767',
                '#23826F',
                '#AC0000',
            ],
            byLocationTypePieChart: [
                '#E50000',
                '#1A4D66',
                '#4A5767',
                '#23826F',
                '#AC0000',
            ],
            byPlatformPerCardTypePieChart: [
                '#E50000',
                '#1A4D66',
                '#4A5767',
                '#23826F',
                '#AC0000',
            ],
            byStatusPieChart: [],
            byWinLossPieChart: [],
        },
        radialBarCharts: {
            fill: '#E50000',
        },
    },
    lockAndUnlockButton: {
        lockButton: {},
        unlockButton: {},
    },
    lampColors: {
        green: '#57a537',
        red: '#cb2022',
        orange: '#d87707',
        yellow: '#d8d800',
        grey: 'grey',
    },
    uploadDnD: {
        borderColor: `#cb2022`,
        backgroundColor: `rgba(203,32,34,.1)`,
        labelColor: `#cb2022`,
    },
    metricTile: {
        arrow: {
            width: 28,
            height: 28,
        },
    },
    caseBuilder: {
        color: '#AC0000',
        saveAndContinueBtn: {
            margin: '0px',
            fontWeight: 700,
            textTransform: 'capitalize',
            backgroundColor: '#AC0000',

            '&:hover': {
                backgroundColor: '#AC0000',
            },
        },
        submittingColor: '#3399CC',
    },
    accentAreaTopBorderAccent: {
        backgroundColor: '',
        borderRadius: '',
    },
    dateRangeContainer: {
        borderRadius: '',
        padding: '7px 8px',
    },
    selectionBox: {
        borderRadius: '4px',
    },
    formFields: {
        formLabel: {},
        formText: {
            standard: {
                color: '#27272a',
            },
            outlined: {
                fontSize: '',
            },
        },
    },
    labelTags: {
        borderRadius: '16px',
        backgroundColor: '#e4e4e7',
    },
    searchBar: {
        padding: '6px',
    },
    buttons: {
        styleButton: {
            root: {
                textTransform: 'capitalize',
            },
            contained: {
                textTransform: 'capitalize',
            },
        },
        defaultButton: {
            variant: 'contained',
            style: {
                backgroundColor: '#e4e4e7',
                color: '#27272a',
                '&:hover': {
                    backgroundColor: '#d4d4d8',
                },
            },
        },
        textOrOutlinedButton: {
            variant: 'outlined',
            style: {
                border: '1px solid #DDE2EB !important',
                borderRadius: '4px !important',
                color: '#263238',
                fontWeight: 600,
                padding: '4px 10px',
                fontSize: '14px',
                '&:hover': {
                    backgroundColor: 'rgba(38, 50, 56, 0.04)',
                },
            },
        },
        greyButton: {
            variant: 'contained',
            style: {
                color: '#71717a',
                backgroundColor: '#d4d4d8',
                '&:hover': {
                    color: '#71717a',
                    backgroundColor: '#d4d4d8',
                },
            },
        },
        greenButton: {
            variant: 'contained',
            style: {
                backgroundColor: '#31B98E',
                '&:hover': {
                    backgroundColor: '#23826F',
                },
            },
        },
        activeStateButton: {
            color: '#FFFFFF',
            backgroundColor: '#52525b',
        },
    },
    icons: {
        uploadIcon: '#3399CC',
        dnrAndRevertDnrIcon: '#3399CC',
        toggleUnlockIcon: '#71717a',
        toggleLockIcon: '#E50000',
        editUserIcon: '#1A4D66',
        midPermissionIcon: '#4A5767',
        sitePermissionIcon: '#23826F',
        tempPasswordIcon: '#3399CC',
    },
    main: '#E50000',
    primaryLight: '#E50000',
    primary: '#E50000',
    primaryDark: '#AC0000',
    secondaryLight: '#1A4D66',
    secondary: '#1A4D66',
    secondaryDark: '#1A4D66',
    hyperlink: '#1A4D66',
    textField: '#E50000',
    switch: '#E50000',
    typography: {
        fontColor: {
            primaryText: '',
            secondaryText: '',
        },
        fontFamily: ['Roboto', 'sans-serif'],
        fontFamilyConfig: {
            primary: 'Roboto',
            fallback:
                '-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, Cantarell, Arial, sans-serif',
        },
        h1: {
            fontSize: '35px',
        },
        h2: {
            fontSize: '29px',
        },
        h3: {
            fontSize: '24px',
        },
        h4: {
            fontSize: '20px',
        },
        h5: {
            fontSize: '16px',
        },
        h6: {
            fontSize: '14px',
        },
        subtitle1: {
            fontSize: '16px',
        },
        subtitle2: {
            fontSize: '14px',
        },
        subtitle3: {
            fontSize: '15px',
        },
        subtitle4: {
            fontSize: '14px',
        },
        body1: {
            fontSize: '14px',
        },
        body2: {
            fontSize: '12px',
        },
        button1: {
            fontSize: '14px',
        },
        button2: {
            fontSize: '13px',
        },
        caption: {
            fontSize: '11px',
        },
        overline: {
            fontSize: '11px',
        },
        label: {
            fontSize: '14px',
        },
        dataGrid: {
            tableHeader: {
                fontSize: '12.8px',
            },
            tableBody: {
                fontSize: '14px',
                color: '#52525b',
            },
            tableExpandable: {
                fontSize: '14px',
            },
        },
    },
    shadows: {
        brandShadowLight: 'rgba(229, 0, 0, 0.4)',
    },
}
